import fetchClient, { ApiResponse } from '../api-client'
import { UserPkg } from './types/UserPkg'

export const getUserPkgs = async () => {
  const res = await fetchClient.get<ApiResponse<UserPkg[]>>('/user-pkg')
  return res.data.data
}

export const getOldUserPkgs = async () => {
  const res = await fetchClient.get<ApiResponse<{ response: UserPkg[] }>>('/packages')
  return res.data.data?.response
}
